import { render, staticRenderFns } from "./AdministrativeActsTableSection.vue?vue&type=template&id=684be693&scoped=true&"
import script from "./AdministrativeActsTableSection.vue?vue&type=script&lang=js&"
export * from "./AdministrativeActsTableSection.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeActsTableSection.vue?vue&type=style&index=0&id=684be693&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684be693",
  null
  
)

export default component.exports